import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (backend/modules/pwj220/models/pwj220.go)
// ============================================================

export interface FJ751 {
  fj751_01: string;       // 分析單號(FK)
  fj751_02: number;       // 明細序號
  fj751_11: string;       // 洗標圖示代碼
  fj751_12: string;       // 洗標說明
}

export interface FJ750 {
  fj750_01: string;         // 分析單號
  fj750_11: string;         // 開發單號
  fj750_12: string | null;  // 入單日期
  fj750_13: string;         // 業務代號
  fj750_14: string;         // 廠商收件單號(前段)
  fj750_15: number;         // 廠商收件單項次
  fj750_161: string;        // 產品代號(前6碼)
  fj750_162: string;        // 產品代號(後6碼)
  fj750_17: string;         // 產品名稱
  fj750_171: number;        // 針孔-外 INCH
  fj750_172: number;        // 針孔-內 INCH
  fj750_173: number;        // G/Y 碼重
  fj750_174: number;        // GM/SQM 米平方重
  fj750_18: number;         // 成品布成本
  fj750_19: string;         // 成品布成本單位
  fj750_20: number;         // 貼合類別
  fj750_201: string;        // 貼合類別說明
  fj750_211: string;        // 面布產品代號(前6碼)
  fj750_212: string;        // 面布產品代號(後6碼)
  fj750_22: string;         // 面布組織規格
  fj750_23: number;         // 面布成本
  fj750_24: string;         // 面布成本單位
  fj750_25: string;         // 面布成本貨幣
  fj750_311: string;        // 底布產品代號(前6碼)
  fj750_312: string;        // 底布產品代號(後6碼)
  fj750_32: string;         // 底布組織規格
  fj750_33: number;         // 底布成本
  fj750_34: string;         // 底布成本單位
  fj750_35: string;         // 底布成本貨幣
  fj750_41: string;         // 膜成品代號
  fj750_42: number;         // 膜成本
  fj750_43: string;         // 膜成本單位
  fj750_44: number;         // 織物層數
  fj750_441: string;        // 織物層數說明
  fj750_45: number;         // 貼合方式
  fj750_451: number;        // 貼合方式(來自C系統)
  fj750_452: number;        // 貼合方式2(來自C系統)
  fj750_453: string;        // 貼合方式說明(其他)
  fj750_46: string;         // 加工費代號
  fj750_471: number;        // 面布加工費
  fj750_472: string;        // 面布加工費單位
  fj750_481: number;        // 底布加工費
  fj750_482: string;        // 底布加工費單位
  fj750_491: number;        // 成品布單價
  fj750_492: string;        // 成品布單位
  fj750_50: string;         // 物化性報告說明
  fj750_501: string;        // 物化性報告貨幣
  fj750_51: string;         // 備註代號
  fj750_52: string;         // 備註說明
  fj750_53: number;         // 貼合總成本
  fj750_54: string;         // 貼合總成本單位
  fj750_61: string;         // 物化性報告單1
  fj750_611: string;        // 物化性報告單2
  fj750_612: string;        // 物化性報告單3
  fj750_62: string;         // 入單人員
  fj750_63: string;         // 入單人員部門
  fj750_64: string;         // 業務開發單號(前段)
  fj750_65: string;         // 業務開發單號(後段)
  fj750_76: string;         // 業務分析單號
  fj750_77: string | null;  // 公告開始日
  fj750_78: string | null;  // 公告終止日
  fj750_79: number;         // 洗標總項次
  fj750_80: string;         // 核准狀態
  fj750_91: string;         // 修改人員
  fj750_92: string | null;  // 修改時間
  fj750_93: string;         // 建立人員
  details?: FJ751[];
}

export interface ListResponse {
  data: FJ750[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API Functions
// ============================================================

const BASE = '/api/pwj220';

export const pwj220Api = {
  list: async (page = 1, size = 20, keyword?: string): Promise<ListResponse> => {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get(BASE, { params });
    return res.data;
  },

  get: async (id: string): Promise<FJ750> => {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data;
  },

  loadSourceDraft: async (id: string): Promise<FJ750> => {
    const res = await apiClient.get(`${BASE}/source/${encodeURIComponent(id)}`);
    return res.data;
  },

  create: async (master: Partial<FJ750>, details: Partial<FJ751>[]): Promise<FJ750> => {
    const res = await apiClient.post(BASE, { master, details });
    return res.data;
  },

  update: async (id: string, master: Partial<FJ750>, details: Partial<FJ751>[]): Promise<FJ750> => {
    const res = await apiClient.put(`${BASE}/${id}`, { master, details });
    return res.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${id}`);
  },
};

export default pwj220Api;
